import React from "react";
import "./Team.css";
import Nik from '../../img/Team/Nik.png'
import Ed from '../../img/Team/Ed.png'
import Pavel from '../../img/Team/Pavel.png'
import Ganna from '../../img/Team/Ganna.png'
import Nadiia from '../../img/Team/Nadiia.png'
import i18n, { t } from "i18next";
import { withTranslation } from 'react-i18next'
import { useTranslation } from "react-i18next";

export default class WhoWeAre extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="WhoWeAre_wrap" id='team'>
                <div className="WhoWeAre container">
                    <h3>{t("team.title")}</h3>
                    <div className="WhoWeAre_photo_block">
                        <div className='WhoWeAre_photo_item'>
                            <img className='WhoWeAre_photo' src={Nadiia} alt='' />
                            <p className='WhoWeAre_name'>{t("team.nadiia.name")}</p>
                            <p className='WhoWeAre_position'>{t("team.nadiia.position")}</p>
                        </div>
                        <div className='WhoWeAre_photo_item'>
                            <img className='WhoWeAre_photo' src={Nik} alt='' />
                            <p className='WhoWeAre_name'>{t("team.nik.name")}</p>
                            <p className='WhoWeAre_position'>{t("team.nik.position")}</p>
                        </div>
                        <div className='WhoWeAre_photo_item'>
                            <img className='WhoWeAre_photo' src={Ganna} alt='' />
                            <p className='WhoWeAre_name'>{t("team.ganna.name")}</p>
                            <p className='WhoWeAre_position'>{t("team.ganna.position")}</p>
                        </div>
                        <div className='WhoWeAre_photo_item'>
                            <img className='WhoWeAre_photo' src={Pavel} alt='' />
                            <p className='WhoWeAre_name'>{t("team.pavel.name")}</p>
                            <p className='WhoWeAre_position'>{t("team.pavel.position")}</p>
                        </div>
                        <div className='WhoWeAre_photo_item'>
                            <img className='WhoWeAre_photo' src={Ed} alt='' />
                            <p className='WhoWeAre_name'>{t("team.ed.name")}</p>
                            <p className='WhoWeAre_position'>{t("team.ed.position")}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}